// searchesApi.js
/* (RTK Query service) */

import { createApi, fetchBaseQuery, retry } from "@reduxjs/toolkit/query/react";
import { URLAPI } from "../../configuration";

// original baseQuery
const rawBaseQuery = fetchBaseQuery({
    baseUrl: URLAPI,
    prepareHeaders: (h, { getState }) => {
        const token = getState().auth.user.jwt;
        if (token) h.set("Authorization", `Bearer ${token}`);
        return h;
    },
});

// new baseQuery with automatic retries
const baseQuery = retry(rawBaseQuery, {
    maxRetries: 20, // ⇒ 1 first try + 20 re-tries
    // retryCondition: (error) => error?.status >= 500, // optional
});

export const searchesApi = createApi({
    reducerPath: "searchesApi",
    baseQuery,
    tagTypes: ["Searches"],
    endpoints: (builder) => ({
        getSearches: builder.query({
            /*  arg === { hotelID, body }  */
            query: ({ hotelID, body }) => ({
                url: `/search_requests/no_availability/${hotelID}`,
                method: "POST",
                body,
            }),
            providesTags: ["Searches"],
            keepUnusedDataFor: 60 * 30,
        }),
    }),
});

export const { useGetSearchesQuery } = searchesApi;
